import { Injectable } from '@angular/core';
import { NavListItem } from 'src/app/shared/components/navigator/navigator.component.config';

@Injectable({ providedIn: 'root' })
export class SharedFunctionService {
  private _goRouteCallback?: (item: NavListItem) => void;

  setGoRouteCallback(fn: (item: NavListItem) => void): void {
    this._goRouteCallback = fn;
  }

  callGoRoute(item: NavListItem): void {
    this._goRouteCallback?.(item);
  }

  clearGoRouteCallback(): void {
    this._goRouteCallback = undefined;
  }
}
